<template>
    <or-layout>

        <a-button icon="plus-circle" @click="addGroupsshow" type="primary" ghost>新增分组</a-button>
        <a-table :dataSource="getFZdatalist" :rowKey="item => item.id" :loading="loading" bordered>
            <a-table-column key="title" title="组名" data-index="title" />
            <a-table-column key="groups" title="组标签" data-index="groups" />
            <a-table-column key="status" width="100px;" title="状态">
                <template slot-scope="item">
                    <span v-if="item.status == 1">可用</span>
                    <span v-if="item.status == 0">已禁用</span>
                </template>
            </a-table-column>
            <a-table-column key="active" width="220px" title="操作">
                <template slot-scope="item">
                    <a-button v-if="item.status == 1" @click="tableEdit(item)" class="active_btn" size="small"
                        type="link">编辑
                    </a-button>
                    <a-button v-if="item.status == 1" @click="tabledell(item)" class="active_btn" size="small"
                        type="link">删除
                    </a-button>
                </template>
            </a-table-column>
        </a-table>
        <a-modal :visible="groupsvisible" title="分组管理" @ok="AddGroup" @cancel="closeaddgroupsmodel">
            <a-form>
                <a-input type="hidden" v-model="groupform.id" />
                <a-form-item>
                    <a-input v-model="groupform.title" placeholder="分组名称" />
                </a-form-item>
                <a-form-item>
                    <a-input v-model="groupform.groups" placeholder="分组标签名" />
                </a-form-item>
                <a-form-item>
                    <a-input v-model="groupform.type" placeholder="类型" />
                </a-form-item>
            </a-form>
        </a-modal>
        <!-- 显示分组信息tab -->
        <div class="main">
            <h2 class="groupsTitle">分组信息展示</h2>
            <a-tabs class="row" hide-add type="card" @change="tabChange">
                <a-tab-pane v-for="grouping in getFZdatalist" :key="grouping.groups" :tab="grouping.title">
                    <a-button type="primary" @click="addAuthConfigshow()" class="margin-ten" shape="round">新增变量数据
                    </a-button>
                    <a-table :dataSource="dataList" :rowKey="item => item.id" :loading="loading" :pagination="false"
                        bordered>
                        <a-table-column key="id" title="id" data-index="id" />
                        <a-table-column key="title" title="名字" data-index="title" />
                        <a-table-column key="config_name" title="变量名" data-index="config_name" />
                        <a-table-column key="groups" title="分组" data-index="groups" />
                        <a-table-column key="tip" title="描述" data-index="tip" />
                        <a-table-column key="type" title="字段类型" data-index="type" />
                        <a-table-column key="config_value" title="value" data-index="config_value" />
                        <a-table-column key="active" title="操作">
                            <template slot-scope="item">
                                <a-button @click="AuthconfigEditshow(item)" class="active_btn" size="small" type="dashed"
                                    shape="round">
                                    修改
                                </a-button>
                                <a-button @click="Authconfigdell({ id: item.id })" class="active_btn" size="small"
                                    type="danger" shape="round">
                                    删除
                                </a-button>
                            </template>
                        </a-table-column>
                    </a-table>
                    <div class="textAlignRinght">
                        <br />
                    </div>
                </a-tab-pane>
            </a-tabs>
        </div>
        <!-- 根据组名显示表格 -->
        <a-divider></a-divider>
        <a-modal :visible="AuthConfigvisible" title="变量管理" okText="提交" cancelText="关闭" @ok="AuthConfigSave"
            @cancel="closeAuthConfigmodel">
            <template>
                <a-form>
                    <a-form-item label="名字">
                        <a-input placeholder="名字" v-model="AuthConfigform.title"></a-input>
                    </a-form-item>
                    <a-form-item label="key">
                        <a-input placeholder="key值(英文)" v-model="AuthConfigform.config_name"></a-input>
                    </a-form-item>
                    <a-form-item label="value">
                        <a-input placeholder="value值" v-model="AuthConfigform.config_value"></a-input>
                    </a-form-item>
                    <a-form-item label="描述">
                        <a-input placeholder="描述" v-model="AuthConfigform.tip"></a-input>
                    </a-form-item>
                    <a-form-item label="字段类型">
                        <a-input placeholder="字段类型" v-model="AuthConfigform.type"></a-input>
                    </a-form-item>
                </a-form>
            </template>
        </a-modal>
    </or-layout>
</template>

<script>
import AFormItem from "ant-design-vue/es/form/FormItem";

export default {
    components: {
        AFormItem,
        // addGrouping,
    },
    data() {
        return {
            dataList: [],
            pageinfo: {
                total: 1,//数据总数只能为数字
                current: 1,//当前页数
                pageSize: 99,//每页条数
                showQuickJumper: true,//是否可以快速跳转到某页
                pagecnt: 1//总页数
            },
            groupsvisible: false,
            groupform: {
                id: '',
                title: '',
                groups: '',
                type: ''
            },
            editoradd: false,
            tabsActiveKey: '',
            AuthConfigform: {
                id: '',
                title: '',
                config_name: '',
                groups: '',
                tip: '',
                type: '',
                config_valueL: '',
            },
            AuthConfigvisible: false,
            AuthConfigeditoradd: false,

            loading: false,

            // 新增配置tab变量
            getFZdatalist: [],//分组列表
            tableAddGroupingForm: {
                addgroups: "",
                addtype: "",
                addtitle: '',
            },
            taskPageInfo: {},



            changeDivideGroupsForm: {
                id: '',
                title: '',
            },
        };
    },
    mounted() {
        this.getFZdata();
        //  this.getfenzuList(this.groupsForm);

    },
    methods: {
        // 获取分组接口
        getFZdata() {
            this.$axios
                .post("/api/BasicConfig/getGroups")
                .then((res) => {

                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.getFZdatalist = res.data;
                        this.tabsActiveKey = res.data[0].groups;
                        this.getAuthConfigList();
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        AddGroup() {
            if (this.editoradd) {
                this.$axios
                    .post("/api/BasicConfig/editGroup", {
                        data: {
                            id: this.groupform.id,
                            title: this.groupform.title,
                        }
                    })
                    .then((res) => {
                        console.log('载入数据', res.data)
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            })
                        } else {
                            this.getFZdata();
                            this.groupsvisible = false;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });

            }
            else {
                this.$axios
                    .post("/api/BasicConfig/addGroup", {
                        data: {
                            groups: this.groupform.groups,
                            type: this.groupform.type,
                            title: this.groupform.title,
                        }
                    })
                    .then((res) => {
                        console.log('载入数据', res.data)
                        if (res.code != 200) {
                            this.$error({
                                title: "错误",
                                content: res.msg,
                                okText: "确定",
                            })
                        } else {
                            this.getFZdata();
                            this.groupsvisible = false;
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                    });
            }
        },
        addGroupsshow() {
            this.groupsvisible = true;
            this.editoradd = false;
            this.groupform = {};
        },

        addAuthConfigshow() {
            this.AuthConfigvisible = true;
            this.AuthConfigeditoradd = false;
            this.AuthConfigform = {};
        },
        closeAuthConfigmodel() {
            this.AuthConfigvisible = false;
        },
        closeaddgroupsmodel() {
            this.groupsvisible = false;
        },
        AuthconfigEditshow(item) {
            this.AuthConfigeditoradd = true;
            this.AuthConfigvisible = true;
            this.AuthConfigform = item;
        },

        Authconfigdell(item) {
            let _this = this;
            this.$confirm({
                title: "删除分组",
                content: "确认删除当前分组吗?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/BasicConfig/delAuthConfig", {
                            data: {
                                id: item.id
                            }
                        })
                        .then((res) => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定",
                                });
                            } else {
                                _this.getAuthConfigList();
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                },
            });
        },


        tableEdit(item) {
            this.groupform.groups = item.groups,
                this.groupform.type = item.type,
                this.groupform.title = item.title,
                this.groupform.id = item.id
            this.groupsvisible = true;
            this.editoradd = true;
        },

        tabledell(item) {
            let _this = this;
            this.$confirm({
                title: "删除分组",
                content: "确认删除当前分组吗?",
                okText: "确认",
                cancelText: "取消",
                onOk: function () {
                    _this.$axios
                        .post("/api/BasicConfig/delGroup", {
                            data: {
                                id: item.id
                            }
                        })
                        .then((res) => {
                            if (res.code != 200) {
                                _this.$error({
                                    title: "错误",
                                    content: res.msg,
                                    okText: "确定",
                                });
                            } else {
                                _this.getFZdata();
                            }
                        })
                        .catch((err) => {
                            console.error(err);
                        });
                },
            });
        },





        tabChange(val) {
            this.tabsActiveKey = val
            this.getAuthConfigList()
        },

        getAuthConfigList() {
            this.$axios
                .post("/api/BasicConfig/getAuthConfigList", {
                    data: {
                        groups: this.tabsActiveKey
                    },
                    pageinfo: {
                        current: this.pageinfo.current,
                        pageSize: this.pageinfo.pageSize,
                    }
                })
                .then((res) => {
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                    } else {
                        this.dataList = res.data.data;
                        this.pageinfo.total = res.data.pageinfo.total;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        // 添加事件
        AuthConfigSave() {
            this.AuthConfigform.groups = this.tabsActiveKey;
            this.loading = true;
            this.$axios
                .post("/api/BasicConfig/saveAuthConfig", {
                    data: this.AuthConfigform
                })
                .then((res) => {
                    this.loading = false;
                    if (res.code != 200) {
                        this.$error({
                            title: "错误",
                            content: res.msg,
                            okText: "确定",
                        });
                        this.loading = false;
                    } else {
                        this.getAuthConfigList();
                        this.AuthConfigvisible = false;
                        this.loading = false;
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },
    },

};
</script>
<style>
.active_btn {
    margin-left: 5px;
}

.back-grey {
    padding: 10px;
    background-color: gainsboro;
}

.font-weight {
    font-weight: bold;
}

.margin-ten {
    margin: 10px;
}

.textAlignRinght {
    padding: 10px 0;
    text-align: right;
}

.groupsTitle {
    font-weight: bold;
}
</style>
